// Mock data for Deus Estate

export const services = [
{
  id: 'real-estate',
  title: 'Недвижими имоти',
  icon: 'Building2',
  description: 'Професионално посредничество при покупка, продажба и отдаване под наем на имоти и парцели.',
  forWhom: 'За собственици, купувачи и инвеститори, които търсят надеждно посредничество при сделки с имоти.',
  benefits: [
  'Професионална оценка на пазарна стойност',
  'Пълна правна проверка на документите',
  'Съпровождане през целия процес',
  'Маркетинг и реклама при продажба',
  'Договаряне на най-добрата цена']

},
{
  id: 'consulting',
  title: 'Консултации и анализи',
  icon: 'TrendingUp',
  description: 'Детайлни пазарни анализи и инвестиционни стратегии за информирани решения.',
  forWhom: 'За инвеститори и бизнес клиенти, които искат да вземат информирано решение.',
  benefits: [
  'Детайлен анализ на пазарната ситуация',
  'Оценка на инвестиционния потенциал',
  'Прогнози и сценарии за развитие',
  'Персонализирана инвестиционна стратегия',
  'Мониторинг и последващи консултации']

},
{
  id: 'legal-finance',
  title: 'Право и финанси',
  icon: 'Scale',
  description: 'Правна сигурност с екип адвокати и финансови решения с 13 банки партньори.',
  forWhom: 'За клиенти, които се нуждаят от правна сигурност и финансови решения.',
  benefits: [
  'Правни становища от екип адвокати',
  'Проверка на собствеността и тежестите',
  'Кредитни консултации и одобрения',
  'Партньорство с 13 водещи банки',
  'Застрахователни услуги']

},
{
  id: 'construction',
  title: 'Строителство и услуги',
  icon: 'Hammer',
  description: 'Цялостни решения за строителство, ремонти и строителни материали.',
  forWhom: 'За клиенти, които търсят цялостни решения за строителство и ремонти.',
  benefits: [
  'Строителни материали на търговски цени',
  'Професионални ремонтни услуги',
  'Проектиране и строителен надзор',
  'Хамалски и логистични услуги',
  'Гаранция върху извършената работа']

}];


export const processSteps = [
{
  number: '01',
  title: 'Диагностика на нуждата',
  description: 'Детайлен разговор за целите ви, бюджета и времевите рамки. Анализираме вашата ситуация и определяме най-подходящия подход.'
},
{
  number: '02',
  title: 'Анализ и сценарии',
  description: 'Изготвяме пазарен анализ и представяме различни варианти за действие с техните плюсове, минуси и рискове.'
},
{
  number: '03',
  title: 'Правна и финансова рамка',
  description: 'Осигуряваме правната проверка, финансовото структуриране и всички необходими документи за сигурна сделка.'
},
{
  number: '04',
  title: 'Сделка и последваща подкрепа',
  description: 'Съпровождаме ви до финализирането и предлагаме последваща поддръжка за всички възникнали въпроси.'
}];


export const team = [
{
  name: 'Захарий Стоянов',
  position: 'Основател и управител',
  bio: "\u0421 \u043D\u0430\u0434 11 \u0433\u043E\u0434\u0438\u043D\u0438 \u043E\u043F\u0438\u0442 \u0432 \u043E\u0431\u043B\u0430\u0441\u0442\u0442\u0430 \u043D\u0430 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u0438\u0442\u0435 \u0438\u043C\u043E\u0442\u0438, \u0417\u0430\u0445\u0430\u0440\u0438\u0439 \u0421\u0442\u043E\u044F\u043D\u043E\u0432 \u0435 \u0438\u0437\u0433\u0440\u0430\u0434\u0438\u043B \u0440\u0435\u043F\u0443\u0442\u0430\u0446\u0438\u044F \u043D\u0430 \u043A\u043E\u043D\u0441\u0443\u043B\u0442\u0430\u043D\u0442, \u043A\u043E\u0439\u0442\u043E \u043F\u043E\u0441\u0442\u0430\u0432\u044F \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u0438\u0442\u0435 \u043D\u0430 \u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u043D\u0430 \u043F\u044A\u0440\u0432\u043E \u043C\u044F\u0441\u0442\u043E. \u0421\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0437\u0438\u0440\u0430 \u0441\u0435 \u0432 \u0438\u043D\u0432\u0435\u0441\u0442\u0438\u0446\u0438\u043E\u043D\u043D\u0438 \u0441\u0442\u0440\u0430\u0442\u0435\u0433\u0438\u0438 \u0438 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u043D\u0438 \u0438\u043C\u043E\u0442\u043D\u0438 \u0441\u0434\u0435\u043B\u043A\u0438. \n\u0417\u0430\u0432\u044A\u0440\u0448\u0438\u043B \u0431\u0430\u043A\u0430\u043B\u0430\u0432\u044A\u0440 \u043F\u043E \u0420\u0435\u0433\u0438\u043E\u043D\u0430\u043B\u043D\u043E \u0420\u0430\u0437\u0432\u0438\u0442\u0438\u0435 \u0438 \u043C\u0430\u0433\u0438\u0441\u0442\u0440\u0430\u0442\u0443\u0440\u0430 \u043F\u043E \u0420\u0435\u0433\u0438\u043E\u043D\u0430\u043B\u0435\u043D \u0431\u0438\u0437\u043D\u0435\u0441 \u0438 \u043C\u0435\u043D\u0438\u0434\u0436\u043C\u044A\u043D\u0442, \u0441\u043B\u0435\u0434 \u043A\u043E\u0435\u0442\u043E \u0437\u0430\u043F\u0438\u0441\u0432\u0430 \u0434\u043E\u043A\u0442\u043E\u0440\u0430\u043D\u0442\u0443\u0440\u0430 \u0432 \u0441\u0444\u0435\u0440\u0430\u0442\u0430 \u043D\u0430 \u0420\u0435\u0433\u0438\u043E\u043D\u0430\u043B\u043D\u043E\u0442\u043E \u0440\u0430\u0437\u0432\u0438\u0442\u0438\u0435 \u0441 \u0444\u043E\u043A\u0443\u0441 \u0432\u044A\u0440\u0445\u0443 \u0440\u0430\u0437\u0432\u0438\u0442\u0438\u0435\u0442\u043E \u043D\u0430 \u0438\u043D\u0442\u0435\u043B\u0438\u0433\u0435\u043D\u0442\u043D\u0438 \u0440\u0435\u0448\u0435\u043D\u0438\u044F \u0432 \u043F\u0440\u0435\u0432\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0435\u0434\u0438\u043D \u0433\u0440\u0430\u0434 \u0432 \u0438\u043D\u0442\u0435\u043B\u0438\u0433\u0435\u043D\u0442\u0435\u043D. \n\n\u041E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0442\u043E, \u043A\u0430\u043A\u0442\u043E \u0438 \u0443\u0447\u0430\u0441\u0442\u0438\u0435\u0442\u043E \u0432 \u043C\u043D\u043E\u0436\u0435\u0441\u0442\u0432\u043E \u0441\u0435\u043C\u0438\u043D\u0430\u0440\u0438, \u043E\u0431\u0443\u0447\u0435\u043D\u0438\u044F \u0438 \u043F\u0440\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u0437\u0430\u043D\u044F\u0442\u0438\u044F \u0434\u0430\u0432\u0430\u0442 \u0437\u0430\u0434\u044A\u043B\u0431\u043E\u0447\u0435\u043D\u043E \u0430\u043D\u0430\u043B\u0438\u0437\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u0440\u0430\u0437\u043B\u0438\u0447\u043D\u0438 \u043A\u0430\u0437\u0443\u0441\u0438 \u0438 \u0441\u0438\u0442\u0443\u0430\u0446\u0438\u0438, \u0441\u043B\u0435\u0434 \u043A\u043E\u0435\u0442\u043E \u043A\u043B\u0438\u0435\u043D\u0442\u0438\u0442\u0435 \u043C\u043E\u0433\u0430\u0442 \u0434\u0430 \u0441\u0435 \u0434\u043E\u0432\u0435\u0440\u044F\u0442, \u0447\u0435 \u0434\u043E\u0441\u0442\u0438\u0433\u0430\u0442 \u0434\u043E \u0435\u0434\u043D\u043E \u043D\u0430\u0438\u0441\u0442\u0438\u043D\u0430 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0430\u043D\u043E \u0438 \u0440\u0430\u0446\u0438\u043E\u043D\u0430\u043B\u043D\u043E \u0440\u0435\u0448\u0435\u043D\u0438\u0435 \u043F\u0440\u0438 \u0441\u0432\u043E\u044F\u0442\u0430 \u043F\u043E\u043A\u0443\u043F\u043A\u0430 \u0438\u043B\u0438 \u043F\u0440\u043E\u0434\u0430\u0436\u0431\u0430. ",
  image: '/images/team-zahary.jpg'
},
{
  name: 'Цветелина Войнова',
  position: 'Консултант недвижими имоти',
  bio: 'Експерт в областта на жилищните имоти и инвестиционни решения. Цветелина осигурява персонализиран подход към всеки клиент и детайлен анализ на пазарните възможности.',
  image: '/images/team-tsvetelina.jpg'
}];


export const trustIndicators = [
{
  icon: 'Users',
  text: 'Екип от юристи и адвокати'
},
{
  icon: 'Landmark',
  text: 'Финансови решения с 13 банки'
},
{
  icon: 'LineChart',
  text: 'Детайлни пазарни анализи'
},
{
  icon: 'ShieldCheck',
  text: 'Пълна правна сигурност'
}];


export const faqs = [
{
  question: 'Как определяте цената на имота?',
  answer: 'Използваме комбинация от пазарни анализи, сравними продажби в района, текущо състояние на имота и инвестиционния потенциал. Нашата оценка се базира на реални пазарни данни.'
},
{
  question: 'Какво включва правната проверка?',
  answer: 'Проверяваме собствеността, наличието на тежести, съответствие с устройствените планове, данъчни задължения и всички правни аспекти, които могат да повлияят на сделката.'
},
{
  question: 'Какви са стъпките при кандидатстване за кредит?',
  answer: 'Анализираме финансовите ви възможности, подготвяме документацията, представяме заявката в подходящите банки от нашата мрежа и съпровождаме процеса до одобрение.'
},
{
  question: 'Колко време отнема една сделка?',
  answer: 'Зависи от сложността, но обикновено жилищните сделки се финализират за 4-8 седмици, а по-сложните инвестиционни проекти могат да отнемат 2-3 месеца.'
},
{
  question: 'Какви са вашите такси?',
  answer: 'Работим с прозрачна тарифа, която обсъждаме предварително. За консултациите първата среща е безплатна, а цените за другите услуги зависят от обхвата на работа.'
},
{
  question: 'Предлагате ли гаранции?',
  answer: 'Да, предлагаме гаранция за качеството на правните ни становища и строителните услуги. При проблем поемаме отговорност за коригиране на грешките.'
}];


export const insights = [
{
  title: 'Пазарен преглед Q1 2026',
  summary: 'Анализ на тенденциите в сектора на жилищните имоти и прогнози за развитието през следващите месеци.',
  date: '15 Януари 2026'
},
{
  title: 'Инвестиционни възможности в София',
  summary: 'Детайлен преглед на перспективните квартали и райони за инвестиции с очакван потенциал за растеж.',
  date: '8 Януари 2026'
},
{
  title: 'Правни промени в имотното законодателство',
  summary: 'Актуални промени в законодателството и как те влияят на процеса на покупко-продажба.',
  date: '22 Декември 2025'
}];